import { useState, useEffect } from 'react';
import axios from 'axios';
import { getUrl } from '../config';

const useSettings = () => {
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchSettings = async () => {
    try {
      setLoading(true);
      const response = await axios.get(getUrl() + `/api/getSettings`);
      if (response.data.status === 'success') {
        setSettings(response.data.data);
        setError(null);
      } else {
        setError('Erreur lors de la récupération des paramètres');
      }
    } catch (error) {
      console.error("Erreur lors de la récupération des paramètres :", error);
      setError('Erreur lors de la récupération des paramètres');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSettings();
  }, []);

  return { settings, loading, error, refetch: fetchSettings };
};

export default useSettings; 